import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=f37951fc&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=ts&"
export * from "./Agreement.vue?vue&type=script&lang=ts&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=f37951fc&scoped=true&lang=css&"
import style1 from "./Agreement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37951fc",
  null
  
)

export default component.exports